import { EnvironmentUrls } from 'Roblox';
import { AxiosResponse, httpService } from 'core-utilities';
import { TPunishment } from './types';

const punishmentsUrl = `${EnvironmentUrls.userModerationApi}/v1/not-approved`;

const fetchPunishmentData = async (): Promise<AxiosResponse<TPunishment | null>> => {
  const urlConfig: { url: string; withCredentials: boolean } = {
    url: punishmentsUrl,
    withCredentials: true
  };
  return httpService.get(urlConfig);
};

export default fetchPunishmentData;
